import BillDetailsContainer from "@legacy/bills/BillDetailsContainer"

import useToastQueue from "@hooks/useToastQueue"

import { AppFrame } from "@templates"

export default function BillPublicDetails() {
    const { addToastToQueue } = useToastQueue()
    return (
        <AppFrame.Root navigationType="none">
            <AppFrame.PageContent>
                <BillDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
